import React, { ReactElement } from 'react';
import Block from '../../Layout/Block';
import DescriptionImage from '../../Layout/DescriptionImage/DescriptionImage';
import '../../Layout/Main.scss';
import '../home.scss';
import TrackableLink from '../../TrackableLink';

const NeubauprojekteInfo = (): ReactElement => (
  <div style={{ paddingBottom: '2rem' }}>
    <div className="p-grid">
      <div className="lg:col-6 titleSpacer" />
      <div className="lg:col-6">
        <div className="bigH1">Neubau-Updates</div>
        <div className="spacer" />
      </div>
    </div>
    <div className="p-grid">
      <div className="lg:col-6 imageCol">
        <DescriptionImage
          link="/downloads"
          linkTitle="Downloads"
          linkAriaLabel="Wer bietet in Wien Neubauprojekte an?"
          src="/home/bautraeger-genossenschaften-makler-neubauprojekte-wien.png"
          alt="bautraeger-genossenschaften-makler-neubauprojekte-wien"
          descriptionTitle="Wer bietet in Wien Neubauprojekte an?"
          description="Liste der Bauträger, Genossenschaften und Makler in Wien als PDF
          downloaden"
          disableShadow
        />
      </div>
      <div className="lg:col-6">
        <h2>Immobilienpreise Wien 2020</h2>
        <h3>Auswertung aktueller Neubauprojekte in Wien</h3>
        <Block>
          Wir haben Preise aktueller Neubauprojekte erhoben und für Sie
          zusammengefasst. Unter folgendem Link finden Sie die aktuellen
          Immobilienpreise für Eigentumswohnungen und Mietwohnungen
          aufgeschlüsselt nach Bezirken.
          <br />
          <TrackableLink
            to="/immobilienpreise-wien-2020/"
            className="inlineLink"
          >
            {'>'} Weiter zu den Immobilienpreisen
          </TrackableLink>
        </Block>

        <h2>Bauträger mit Neubauprojekten in Wien</h2>
        <h3>Mehr Überblick mit der neuen Bauträger-Liste</h3>
        <Block>
          Sie wollen wissen, welche Bauträger in Wien Neubauprojekte errichten?
          Dann sind sie hier genau richtig! Wir listen derzeit 133 Bauträger.
          Gerne können Sie sich die Bauträger-Liste auch als PDF herunterladen.
          <br />
          <TrackableLink to="/bautraeger-wien/" className="inlineLink">
            {'>'} Weiter zur Bauträger-Liste
          </TrackableLink>
        </Block>

        <h2>Makler mit Neubauprojekten in Wien</h2>
        <h3>Vermittler von Neubau-Wohnungen in Wien</h3>
        <Block>
          Auch Makler sind spezialisiert auf den Vertrieb von Neubauprojekten.
          Die Makler-Liste steht ebenfalls als PDF zum Download zu Verfügung.
          <br />
          <TrackableLink to="/makler-wien/" className="inlineLink">
            {'>'} Weiter zur Makler-Liste
          </TrackableLink>
        </Block>
      </div>
    </div>
  </div>
);

export default NeubauprojekteInfo;
